export default "__VITE_ASSET__CSgx9$5M__"